import { makeRequest } from '../../../lib/api';

const USERS_PATH = '/v1/users';

class partnerController {
  getCronTaskList = () => {
    return makeRequest('get', `${ USERS_PATH }/cron_tasks`);
  };

  getCronTaskRunHistory = (cronTaskId) => {
    return makeRequest('get', `${ USERS_PATH }/cron_task_run_history?cronTaskId=${ cronTaskId }`);
  };
}

export default new partnerController();
